module.exports = __webpack_public_path__ + "03_medium_gray.e368e324.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/03_medium_gray.png
// module id = P3v3
// module chunks = 0